import { OrderInfoContext } from 'entities/orders/lib/helpers/provider/context';
import { useState, ReactNode, FC, useCallback } from 'react';

interface OrderInfoProviderProps {
	children: ReactNode;
}

export const OrderInfoProvider: FC<OrderInfoProviderProps> = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedId, setSelectedId] = useState<number>(0);
	const [selectedInfoId, setSelectedInfoId] = useState<number>(0);

	const toggleOpen = () => {
		setIsOpen(prev => !prev);
	};

	const open = () => {
		setIsOpen(true);
	};

	const close = useCallback(() => {
		setIsOpen(false);
	}, []);

	return (
		<OrderInfoContext.Provider
			value={{
				isOpen,
				toggleOpen,
				selectedId,
        selectedInfoId,
				setSelectedId,
        setSelectedInfoId,
				close,
				open,
			}}
		>
			{children}
		</OrderInfoContext.Provider>
	);
};
